import { Draft, PayloadAction } from '@reduxjs/toolkit';
import EWorkerType from 'enums/workerTypes';

import IGetAllWorkerListResponse from 'services/httpClient/responses/worker/IGetAllWorkerListResponse';

import { IWorkerData } from '../../initialState';

export interface IGetAllWorkersSuccessWithDataAction {
  list: IGetAllWorkerListResponse[];
}

function getAllSuccessWithData(
  draft: Draft<IWorkerData>,
  action: PayloadAction<IGetAllWorkersSuccessWithDataAction>,
) {
  draft.getAll.config.errorMsg = '';
  draft.getAll.config.emptyMsg = '';
  draft.getAll.config.isLoading = false;
  draft.getAll.list = action.payload.list.map(worker => {
    let workerType = '';

    switch (true) {
      case worker.accountant:
        workerType = EWorkerType.Accountant;
        break;

      case worker.technician:
        workerType = EWorkerType.Technician;
        break;

      default:
        workerType = EWorkerType.Admin;
        break;
    }

    const workerFormatted = {
      ...worker,
      fullName: `${worker.firstname} ${worker.lastname}`,
      type: workerType,
    };

    return workerFormatted;
  });
}

export default getAllSuccessWithData;
